import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Permissions } from '@upstart/harmony/lib/constants';
import withUserPermission from './userPermission';

function AddButton({ dealerId }) {
  return (
    <Link
      className="btn btn-primary btn-large new-btn-space"
      to={{ pathname: `/${dealerId}/users/user/` }}
    >
      Add New
    </Link>
  );
}

AddButton.propTypes = {
  dealerId: PropTypes.string,
};

export default withUserPermission(Permissions.CREATE)(AddButton);
